import React from 'react'
import { useOutletContext } from 'react-router-dom'

import EventsLayout from '../components/EventsLayout/EventsLayout'

const EventsAwards = () => {
  const {
    sectiondata,
    pagination,
    emptyMessage = '',
  } = useOutletContext() || {}

  return (
    <EventsLayout
      data={sectiondata}
      pagination={pagination}
      emptyMessage={emptyMessage}
    />
  )
}

export default EventsAwards
